import { render, staticRenderFns } from "./takeoutSideboardOrderDeviceCount.vue?vue&type=template&id=41c18bd0&scoped=true&"
import script from "./takeoutSideboardOrderDeviceCount.vue?vue&type=script&lang=js&"
export * from "./takeoutSideboardOrderDeviceCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c18bd0",
  null
  
)

export default component.exports